import React, { useEffect, useState } from 'react';
import logo from '../../logo.svg';
import LayoutStyle from './layout.module.css';
import { Form, Input, Button, Checkbox } from 'antd';
import { LockFilled, UserOutlined } from '@ant-design/icons';
import { auth, db, DB_TYPE } from '../Firestore';
import { useUser } from '../hook/UserHook';

import md5 from 'md5';

export default function AuthenScreen (props) {
    const { user, login, openLogin } = useUser();
    // const [form] = Form.useForm();

    var originNotice = props.notice;
    var [notice, setNotice] = useState(props.notice);
    var [disable, setDisable] = useState(false);
    var [email, setEmail] = useState("");
    const signInSuccess = props.signInSuccess;

    useEffect(() => {
        if (originNotice) {
            setNotice(originNotice);
            setDisable(false);
        }
    }, [originNotice]);

    // const handleSubmit = e => {
    //     e.preventDefault();
    //     props.form.validateFields((err, values) => {
    //         if (!err) {
    //             console.log('Received values of form: ', values);
    //             onLogin(values.username, values.password);
    //         }
    //     });
    // };

    const onLogin = async (name, pass) => {
        // setDisable(true);
        var success = true;
        setNotice("");

        const res = await login(name, pass);
        if(res.success) {
            console.log("Login Success: ", res)
        }
        setDisable(false)

        // const key = md5(name + pass);
        // db.collection(key).doc("users").get().then((doc) => {
        //     if (doc.exists && doc.data().permission === 0 && doc.data().type === 0) {
        //         getUserInfo(doc.data().uid);
        //     } else {
        //         setNotice("Invalid user or password");
        //         setDisable(false);
        //     }
        // }).catch((error) => {
        //     setNotice("Error:" + error.message);
        //     setDisable(false);
        // });
    }

    // const { getFieldDecorator } = form;

    const onFinish = values => {
        console.log('Received values of form: ', values);
        onLogin(values.username, values.password);
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    return (
        <div className={LayoutStyle.body} style={{ height: "96vh", width: "100vw" }}>
            <div className={LayoutStyle.login_container}>
                <img src={logo} className={LayoutStyle.logo} alt="logo" />
                <Form 
                // className="login-form"
                    // form={form}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{ remember: true, username: "grouptedy@gmail.com" }}>
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Please input your username!' }]}
                    >
                        <Input
                            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)', backgroundColor: 'transperant' }} />}
                            placeholder="Username"
                            disabled={disable}
                        />
                    </Form.Item>
                    <Form.Item
                        style={{ marginBottom: "10px" }}
                        name='password'
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                    >
                        <Input.Password
                            prefix={<LockFilled style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Password"
                            disabled={disable} 
                            />

                    </Form.Item>
                    <span style={{ color: "red" }}>{notice}</span>
                    <Form.Item
                        name='remember'
                        valuePropName='checked'
                    >
                        <Checkbox style={{ color: "white" }}>Remember me</Checkbox>
                        <a style={{ float: "right" }} href="">Forgot password</a>
                    </Form.Item>
                    <Form.Item
                        label={null}
                    >
                        <Button type="primary" htmlType='submit'  style={{ width: "100%", height: "30px", marginTop: "15px" }} 
                        disabled={disable}
                        >
                            Đăng nhập
                        </Button>
                    </Form.Item>
                </Form>
                
            </div>
        </div>
    );
}